var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Vue App")]),(_vm.user)?_c('h2',[_vm._v("欢迎回来，"+_vm._s(_vm.user.name))]):_vm._e(),_c('div',[_vm._v(" "+_vm._s(JSON.stringify(_vm.user, null, 2))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }